import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, unref as _unref, Fragment as _Fragment, createBlock as _createBlock, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "w-full flex items-baseline"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "text-[12.8px] text-mcgard-gray-800 whitespace-nowrap label"
}
const _hoisted_7 = {
  key: 1,
  class: "text-[12.8px] text-mcgard-gray-800 whitespace-nowrap label"
}
const _hoisted_8 = {
  key: 1,
  class: "text-wrapper w-full flex items-baseline justify-between mr-2"
}
const _hoisted_9 = {
  key: 0,
  class: "placeholder text-mcgard-gray-500 text-[12.8px] label"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "text-[12.8px] text-mcgard-gray-800 whitespace-nowrap label"
}
const _hoisted_13 = {
  key: 2,
  class: "label text-[12.8px] text-mcgard-gray-800 whitespace-nowrap label"
}
const _hoisted_14 = { class: "h-full flex items-center justify-center" }
const _hoisted_15 = {
  key: 0,
  class: "h-[18px] w-px bg-mcgard-gray-200 mx-3"
}
const _hoisted_16 = { class: "absolute top-0 left-0 w-full h-full flex items-center justify-center backdrop-blur-sm" }
const _hoisted_17 = {
  key: 0,
  class: "relative h-full text-center py-10"
}
const _hoisted_18 = {
  key: 1,
  class: "h-full"
}
const _hoisted_19 = {
  key: 2,
  class: "h-full overflow-y-auto"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "w-full flex items-center justify-between py-0.5 leading-6 text-left min-h-[26px]" }

import IconCaret from '@/components/icons/IconCaret.vue';
import IconClose from '@/components/icons/IconClose.vue';
import Loading from 'vue3-loading-overlay/dist/index';

import { BaseSelectDropdownItem, BaseSelectDropdownItemState } from '@/utils/types/index';

import { onClickOutside } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import { computed, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSelectDropdown',
  props: {
    modelValue: null,
    placeholder: { default: '' },
    width: { default: '' },
    items: null,
    className: { default: '' },
    triggerClassName: { default: '' },
    isRounded: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    isLoadingInit: { type: Boolean, default: false },
    divider: { type: Boolean, default: false },
    customIcon: { type: Boolean, default: false },
    isObjValue: { type: Boolean, default: false },
    objKey: { default: 'key' },
    isRelative: { type: Boolean, default: false },
    isSingleSelected: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    topPlaceHolder: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "on-select-item", "on-clear"],
  setup(__props: any, { expose, emit }: { emit: ({
  (
    event: 'update:modelValue',
    data: any[]
  ): void,
  (event: 'on-select-item'): void,
  (event: 'on-clear'): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: any[], placeholder: string, width: string, items: BaseSelectDropdownItem[] | [], className: Array<string> | string, triggerClassName: Array<string> | string, isRounded: boolean, isLoading: boolean, isLoadingInit: boolean, divider: boolean, customIcon: boolean, isObjValue: boolean, objKey: string, isRelative: boolean, isSingleSelected: boolean, required: boolean, topPlaceHolder: boolean, disabled: boolean };





expose({
  reset,
  setSelectedItemState,
});

const { t } = useI18n();

const itemsOptionState = ref([] as BaseSelectDropdownItemState[]);
const selectedItems = ref([] as BaseSelectDropdownItemState[]);
const isOpen = ref(false);
const dropdownRef = ref(null);

// Computed
const getSelectedLabelText = computed(() => {
  if (selectedItems.value.length === 0) {
    return '';
  }
  return selectedItems.value.slice().map((item) => t(item.label)).join();
});
const getSelectedValues = computed(() => {
  if (selectedItems.value.length === 0) {
    return [];
  }
  return selectedItems.value.slice().map((item) => item.value);
});

// Watchers
watch(() => props.items, () => {
  setItemsOptionState();
});
watch(() => props.modelValue, () => {
  if (props.modelValue.length === 0) {
    reset();
  }
});

// Methods
function initSetSelectedItemState() {
  if (itemsOptionState.value.length === 0) {
    return;
  }
  selectedItems.value = itemsOptionState.value.slice()
    .filter((item) => item.selected);
}
function setItemsOptionState() {
  if (props.items.length === 0) {
    return;
  }
  itemsOptionState.value = props.items.slice().map((item) => {
    const stringSelectedValues = !props.modelValue || props.modelValue.length === 0 ? [''] : props.modelValue.map((v) => v + '');
    const isSelected = stringSelectedValues.find((v: string) => {
      return v === (item.value + '');
    });
    if (!props.modelValue || props.modelValue.length === 0) {
      return {
        value: item.value,
        label: item.label,
        selected: !!isSelected,
      };
    } else {
      return {
        value: item.value,
        label: item.label,
        selected: stringSelectedValues.includes(item.value + ''),
      };
    }
  });
}
function toggleDropdown() {
  isOpen.value = !isOpen.value;
}
function hideDropdown() {
  isOpen.value = false;
}
function onSelectItem(item: BaseSelectDropdownItemState) {
  if (props.isSingleSelected) {
    itemsOptionState.value = props.items.slice().map((optionItem) => {
      if (optionItem.value === item.value) {
        return {
          value: optionItem.value,
          label: optionItem.label,
          selected: !item.selected,
        };
      } else {
        return {
          value: optionItem.value,
          label: optionItem.label,
          selected: false,
        };
      }
    });
    const foundedItem = itemsOptionState.value.find((optionItem) => optionItem.value === item.value);
    if (foundedItem && foundedItem.selected) {
      selectedItems.value = [foundedItem];
    } else {
      selectedItems.value = [];
    }
    emit('update:modelValue', getSelectedValues.value);
    emit('on-select-item');
    hideDropdown();
    return;
  }
  item.selected = !item.selected;
  let stringSelectedValues: string[] = [];
  if (props.isObjValue) {
    stringSelectedValues = props.modelValue.map((objV) => objV[props.objKey] + '');
  } else {
    stringSelectedValues = props.modelValue.map((v) => v + '');
  }

  const isDouble = stringSelectedValues.find((v) => {
    return v === (item.value + '');
  });

  if (item.selected) {
    if(isDouble) {
      return;
    }
    selectedItems.value = [
      ...selectedItems.value,
      item,
    ];
    emit('update:modelValue', getSelectedValues.value);
    emit('on-select-item');
    return;
  }

  let index = 0;
  if (props.isObjValue) {
    index = selectedItems.value.findIndex((selectItem) => (selectItem.value[props.objKey] + '') === (item.value[props.objKey] + ''));
  } else {
    index = selectedItems.value.findIndex((selectItem) => (selectItem.value + '') === (item.value + ''));
  }
  selectedItems.value.splice(index, 1);
  emit('update:modelValue', getSelectedValues.value);
  emit('on-select-item');
}
function reset() {
  selectedItems.value = [];
  // emit('update:modelValue', []);
}
function setSelectedItemState(item: BaseSelectDropdownItemState) {
  if (itemsOptionState.value.length === 0) {
    return;
  }
  onSelectItem(item);
}

/**
 * On start
 * */

// Listen to on click outside
onClickOutside(dropdownRef, () => {
  hideDropdown();
});

// Set option item status
setItemsOptionState();

// Set selectedItems state
initSetSelectedItemState();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "dropdownRef",
    ref: dropdownRef,
    class: _normalizeClass([
      __props.className,
      __props.disabled ? 'pointer-events-none opacity-50' : null,
    ])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([
        'dropdown-trigger dropdown',
        isOpen.value
          ? __props.isRelative
            ? 'is-open h-auto'
            : 'is-open h-10'
          : __props.isRelative
            ? 'h-11 hover:shadow-border-mcgard-gray-300'
            : 'h-10 hover:shadow-border-mcgard-gray-300',
        __props.triggerClassName
      ])
    }, [
      (__props.placeholder.length && __props.topPlaceHolder && selectedItems.value.length)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: _normalizeClass([
          'absolute w-full text-mcgard-gray-500 text-[12.8px] whitespace-nowrap text-clip overflow-hidden',
          'top-[-16px] left-0 text-[10px]'
        ])
          }, [
            _createElementVNode("span", { innerHTML: __props.placeholder }, null, 8, _hoisted_1),
            _createTextVNode(),
            (__props.required)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: _normalizeClass(["dropdown-toggle top-0 left-0 w-full bg-white px-2 flex items-center justify-between z-[1] text-clip overflow-hidden", [
          __props.isRounded ? 'rounded' : null,
          isOpen.value
            ? 'after:absolute after:w-select-dropdown-container after:h-0.5 after:bg-mcgard-gray-200 after:bottom-px after:left-1/2 after:transfrom after:-translate-x-1/2 after:z-[2]'
            : null,
          __props.isRelative
            ? 'relative h-10'
            : 'absolute h-full',
        ]]),
        onClick: toggleDropdown
      }, [
        (__props.topPlaceHolder)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (__props.placeholder.length)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: _normalizeClass([
              'absolute text-mcgard-gray-500 text-[12.8px] whitespace-nowrap label',
              selectedItems.value.length ? 'top-[-16px] left-0 text-[10px]' : 'top-1/2 transform -translate-y-1/2'
            ])
                  }, [
                    _createElementVNode("span", { innerHTML: __props.placeholder }, null, 8, _hoisted_4),
                    _createTextVNode(),
                    (__props.required)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, "*"))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              (selectedItems.value.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (selectedItems.value.length > 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(selectedItems.value.length) + " " + _toDisplayString(_ctx.$t('ITEMS')), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(getSelectedLabelText)), 1))
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (__props.placeholder.length && selectedItems.value.length === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                    _createElementVNode("span", { innerHTML: __props.placeholder }, null, 8, _hoisted_10),
                    _createTextVNode(),
                    (__props.required)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, "*"))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (selectedItems.value.length > 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(selectedItems.value.length) + " " + _toDisplayString(_ctx.$t('ITEMS')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(getSelectedLabelText)), 1))
            ])),
        _createElementVNode("div", _hoisted_14, [
          (__props.divider)
            ? (_openBlock(), _createElementBlock("span", _hoisted_15))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createVNode(_Transition, {
              mode: "out-in",
              "enter-active-class": "transition duration-150",
              "enter-from-class": "opacity-0",
              "enter-to-class": "opacity-100",
              "leave-active-class": "transition duration-150",
              "leave-from-class": "opacity-100",
              "leave-to-class": "opacity-0"
            }, {
              default: _withCtx(() => [
                (isOpen.value)
                  ? (_openBlock(), _createBlock(IconClose, {
                      key: 0,
                      "class-stroke": "stroke-mcgard-gray-500",
                      size: 10
                    }))
                  : (__props.customIcon)
                    ? _renderSlot(_ctx.$slots, "custom-icon", {
                        key: 1,
                        class: "custom-icon"
                      })
                    : (_openBlock(), _createBlock(IconCaret, {
                        key: 2,
                        class: "caret-icon",
                        size: 24
                      }))
              ]),
              _: 3
            })
          ])
        ])
      ], 2),
      (isOpen.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass([
          'left-0 w-full px-2 pb-2 max-h-[300px] overflow-y-auto bg-white shadow-border-mcgard-gray-300-no-top duration-500 z-[2]',
          __props.isRounded ? 'rounded-b' : null,
          __props.isRelative ? 'relative' : 'absolute top-full',
          __props.isLoading || __props.isLoadingInit ? 'min-h-[34px]' : null,
        ])
          }, [
            _createVNode(_Transition, {
              mode: "out-in",
              "enter-active-class": "transition ease-out duration-100",
              "enter-from-class": "opacity-0",
              "enter-to-class": "opacity-100",
              "leave-active-class": "transition ease-in duration 100",
              "leave-from-class": "opacity-100",
              "leave-to-class": "opacity-0"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_16, [
                  _createVNode(_unref(Loading), {
                    color: "var(--color-primary)",
                    "is-full-page": false,
                    width: 30,
                    height: 30,
                    active: ""
                  })
                ], 512), [
                  [_vShow, __props.isLoading]
                ])
              ]),
              _: 1
            }),
            _createVNode(_Transition, {
              mode: "out-in",
              "enter-active-class": "transition ease-out duration-100",
              "enter-from-class": "opacity-0",
              "enter-to-class": "opacity-100",
              "leave-active-class": "transition ease-in duration 100",
              "leave-from-class": "opacity-100",
              "leave-to-class": "opacity-0"
            }, {
              default: _withCtx(() => [
                (__props.isLoadingInit && isOpen.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createVNode(_unref(Loading), {
                        color: "var(--color-primary)",
                        "is-full-page": false,
                        width: 30,
                        height: 30,
                        active: ""
                      })
                    ]))
                  : (itemsOptionState.value.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.$t('NO-RESULT')), 1))
                    : (_openBlock(), _createElementBlock("ul", _hoisted_19, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsOptionState.value, (item, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: `${item.label}-${index}`,
                            class: _normalizeClass([
                'group border-b border-mcgard-gray-100 hover:bg-mcgard-primary-50',
                index === itemsOptionState.value.length - 1 ? 'border-b-0' : null
              ]),
                            onClick: ($event: any) => (onSelectItem(item))
                          }, [
                            _createElementVNode("button", _hoisted_21, [
                              _createElementVNode("span", {
                                class: _normalizeClass([
                    'font-roboto-medium text-[14px]',
                    _unref(getSelectedValues).includes(item.value) ? 'text-mcgard-primary' : 'text-mcgard-gray-800'
                  ])
                              }, _toDisplayString(_ctx.$t(item.label)), 3),
                              (_unref(getSelectedValues).includes(item.value))
                                ? (_openBlock(), _createBlock(IconClose, {
                                    key: 0,
                                    "class-stroke": "stroke-mcgard-primary",
                                    size: 8
                                  }))
                                : _createCommentVNode("", true)
                            ])
                          ], 10, _hoisted_20))
                        }), 128))
                      ]))
              ]),
              _: 1
            })
          ], 2))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}
}

})